module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-91.59828a5b.svg";